import { render, staticRenderFns } from "./OpportunitiesSection.vue?vue&type=template&id=26647c9c&scoped=true"
import script from "./OpportunitiesSection.vue?vue&type=script&lang=js"
export * from "./OpportunitiesSection.vue?vue&type=script&lang=js"
import style0 from "./OpportunitiesSection.vue?vue&type=style&index=0&id=26647c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26647c9c",
  null
  
)

export default component.exports